import React from "react";
import {
  Accordion,
  Text,
  Group,
  Stack,
  ActionIcon,
  rem,
  Center,
} from "@mantine/core";
import { IconCopy, IconCheck } from "@tabler/icons-react";
import { CopyButton } from "@mantine/core";
import { format } from "date-fns";
import { QRCodeSVG } from "qrcode.react";
import InfoCircle from "../dataDisplay/infoCircle";

const formatDate = (stamp: number) => format(new Date(stamp), "PPPpp");

interface AddressAccordionSectionProps {
  addresses: any[];
  kind: string;
  title: string;
  icon: React.ReactNode;
  description: string;
  infoLink?: string;
}

const AddressAccordionSection: React.FC<AddressAccordionSectionProps> = ({
  addresses,
  kind,
  title,
  icon,
  description,
  infoLink,
}) => {
  return (
    <Accordion.Item value={kind}>
      <Accordion.Control icon={icon}>{title}</Accordion.Control>
      <Accordion.Panel>
        <Group align="center" mb="md">
          <Text size="sm">{description}</Text>
        </Group>
        <Stack>
          {addresses.map((address, index) => (
            <Stack key={index} gap="xs">
              {/* Show QR code only for the first address */}
              {index === 0 && (
                <Center>
                  <QRCodeSVG
                    value={address.address}
                    size={220}
                    bgColor={"#ffffff"}
                    fgColor={"#000000"}
                    level={"L"}
                    marginSize={4}
                  />
                </Center>
              )}
              <Text size="xs" c="dimmed">
                {formatDate(address.stamp)}
              </Text>
              <Group gap="xs" align="center">
                <Text
                  size="xs"
                  style={{ wordBreak: "break-all", maxWidth: "80%" }}
                >
                  {address.address}
                </Text>
                <CopyButton value={address.address}>
                  {({ copied, copy }) => (
                    <ActionIcon
                      size="sm"
                      variant={copied ? "filled" : "default"}
                      color={copied ? "teal" : "blue"}
                      onClick={copy}
                      aria-label="copy address"
                    >
                      {copied ? (
                        <IconCheck size={14} />
                      ) : (
                        <IconCopy size={14} />
                      )}
                    </ActionIcon>
                  )}
                </CopyButton>
              </Group>
            </Stack>
          ))}
        </Stack>
      </Accordion.Panel>
    </Accordion.Item>
  );
};

export default AddressAccordionSection;
